module.exports = __webpack_public_path__ + "img/kommune-1621.40812477.svg";